import { useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import simbol1 from "../../resources/images/symbol4.png";
import symbol3 from "../../resources/images/symbol3.png";
import gifWave from "../../resources/images/scope.gif";
import getProducts from "../../Data/Products";
import { CartContext } from "../../Contexts/CartContext";
import "./TopBar.css";

const TopBar = ({ handlePageChange, currentPage }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cartItems } = useContext(CartContext);
  const isCheckoutPage = location.pathname === "/checkout";
  const isPrivacyPolicyPage = location.pathname === "/privacy-policy";
  const isTermsConditionsPage = location.pathname === "/terms-conditions";

  const products = useMemo(() => getProducts(), []);

  const currentFeature = useMemo(() => {
    return Object.entries(products)
      .flatMap(([key, p]) => (p.extraFeatures || []).map(f => ({ ...f, productId: p.id, productKey: key })))
      .find(f => location.pathname === `/products/${f.productId}/${f.routeSlug}`);
  }, [location.pathname, products]);

  const productsTarget = useMemo(() => {
    if (currentFeature) {
      return `/products/${currentFeature.productKey}`;
    }
    if (isCheckoutPage && cartItems.length === 1) {
      const key = Object.keys(products).find(k => products[k].name === cartItems[0].name);
      if (key) return `/products/${key}`;
    }
    return "/products";
  }, [currentFeature, isCheckoutPage, cartItems, products]);

  useEffect(() => {
    if (location.pathname === "/about") {
      handlePageChange("about");
    } else if (location.pathname === "/products") {
      handlePageChange("products");
    }
  }, [location.pathname, handlePageChange]);

  const handleNavigation = (page, path) => {
    handlePageChange(page);
    navigate(path || (page === "about" ? "/about" : "/products"));
  };

  const renderStaticPage = (label, { navLink } = {}) => (
    <div className="menu-items">
      {navLink && (
        <>
          <div
            onClick={() => handleNavigation(navLink.page, navLink.path)}
            className="topbar-link clickable text-link"
          >
            {navLink.label}
          </div>
          <img src={symbol3} alt="Simbolo" className="simbol3-product-top-bar" />
        </>
      )}
      <div className="topbar-link text-link active">
        {label}
      </div>
    </div>
  );

  return (
    <div className="container-top-vertical-menu">
      <span className="dawned-instruments-top-bar-text" onClick={() => navigate("/")}>
        Dawned Instruments
      </span>{" "}
      <img src={simbol1} alt="Simbolo" className="simbol-product-top-bar" />
      {isCheckoutPage ? (
        renderStaticPage("Checkout", {
          navLink: { page: "products", label: "Products", path: productsTarget },
        })
      ) : isPrivacyPolicyPage ? (
        renderStaticPage("PrivacyPolicy", { navLink: { page: "about", label: "About" } })
      ) : isTermsConditionsPage ? (
        renderStaticPage("Terms & Conditions", { navLink: { page: "about", label: "About" } })
      ) : currentFeature ? (
        renderStaticPage(currentFeature.navLabel.replace("\n", " "), {
          navLink: { page: "products", label: "Products", path: productsTarget },
        })
      ) : (
        <div className="menu-items">
          <div
            onClick={() => handleNavigation("about")}
            className={`topbar-link clickable text-link ${currentPage === "about" ? "active" : ""}`}
          >
            About
          </div>
          <img src={symbol3} alt="Simbolo" className="simbol3-product-top-bar" />
          <div
            onClick={() => handleNavigation("products")}
            className={`topbar-link clickable text-link ${currentPage === "products" ? "active" : ""}`}
          >
            Products
          </div>
        </div>
      )}
      <div>
        <img src={gifWave} alt="Wave Gif" className="gif-wave" />
      </div>
    </div>
  );
};

export default TopBar;
